import { Marker } from '@react-google-maps/api';

// DirectionsRenderer owns fixed markers, so render route stops separately to
// allow A to follow the vehicle while keeping the destination and stops fixed.
export default function RouteMarkers({ route, liveOrigin }) {
    if (!route?.legs?.length) return null;

    const positions = [
        liveOrigin || route.legs[0].start_location,
        ...route.legs.map(leg => leg.end_location),
    ];

    return positions.map((position, index) => (
        <Marker
            key={index}
            position={position}
            label={String.fromCharCode(65 + index)}
            zIndex={index === 0 ? 1001 : undefined}
        />
    ));
}
